export const Resturants = [
    {
        type: "Resturants and Eating Out",
        name: "⭐️ Happy Cow",
        category: "Search",
        author: "",
        description: "",
        link: "https://www.happycow.net/",
        "": "",
    },
    {
        type: "Resturants and Eating Out",
        name: "Google Maps",
        category: "Search",
        author: "",
        description: "",
        link: "https://www.google.com/maps/search/vegan+restaurants/",
        "": "",
    },
    {
        type: "Resturants and Eating Out",
        name: "Yelp Search",
        category: "Search",
        author: "",
        description: "",
        link: "https://www.yelp.com/search?find_desc=vegan+food",
        "": "",
    },
    {
        type: "Resturants and Eating Out",
        name: "Eating Out Tips",
        category: "Information",
        author: "",
        description: "",
        link: "https://veganuary.com/starter-kit/vegan-eating-out-tips/",
        "": "",
    },
    {
        type: "Resturants and Eating Out",
        name: "Fast Food Guide",
        category: "Information",
        author: "",
        description: "",
        link: "https://chooseveg.com/blog/here-are-14-delicious-vegan-options-at-your/",
        "": "",
    },
    {
        type: "Resturants and Eating Out",
        name: "Vanilla Bean",
        category: "Search",
        author: "",
        description: "",
        link: "https://www.vanilla-bean.com/",
        "": "",
    },
]
